export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-66e7f307',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
